type optionsUser = { [Key: string]: string }

export const rolesUsuario /*: optionsUser*/ = {
  ADMINISTRADOR: "Usuarios.Administrador",
  DOE: "Usuarios.DOE",
  ARI: "Usuarios.ARI",
  SECRETARIA: "Usuarios.Secretaria",
  OFICINA_AUXILIAR: "Usuarios.OficinaAuxiliar",
  CONSEJERO: "Usuarios.Consejero",
  CONSEJO_GENERAL: "Usuarios.ConsejoGeneral",
} as const
